"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveSortedColumns = exports.saveColumnFilters = exports.saveHiddenColumns = exports.saveRowsPerPage = exports.getInitialSortedColumns = exports.getInitialColumnFilters = exports.getInitialHiddenColumns = exports.getInitialRowsPerPage = void 0;
var getInitialRowsPerPage = function (tableId, rowsPerPage) {
    if (tableId) {
        var rowsPerPage_1 = localStorage.getItem('table-' + tableId + '-rows-per-page');
        if (rowsPerPage_1) {
            return Number(rowsPerPage_1);
        }
    }
    return rowsPerPage;
};
exports.getInitialRowsPerPage = getInitialRowsPerPage;
var getInitialHiddenColumns = function (tableId, columns) {
    if (tableId) {
        var commaSeparatedHiddenColumnIds = localStorage.getItem('table-' + tableId + '-hidden-columns');
        if (commaSeparatedHiddenColumnIds) {
            return commaSeparatedHiddenColumnIds.split(',').filter(function (id) { return columns.find(function (column) { return column.id === id; }); });
        }
    }
    return [];
};
exports.getInitialHiddenColumns = getInitialHiddenColumns;
var getInitialColumnFilters = function (tableId, columns, data) {
    if (tableId) {
        var columnFiltersString = localStorage.getItem('table-' + tableId + '-column-filters');
        if (columnFiltersString) {
            var columnFilters_1 = JSON.parse(columnFiltersString);
            return Object.keys(columnFilters_1).reduce(function (acc, key) {
                if (columns.find(function (column) { return column.id === key; })) {
                    acc[key] = columnFilters_1[key];
                }
                return acc;
            }, {});
        }
    }
    var result = {};
    columns.filter(function (column) { return column.filter; }).map(function (column) {
        var uniqueValues = new Set();
        data.forEach(function (item) { return uniqueValues.add(column.accessor(item)); });
        result[column.id] = Array.from(uniqueValues);
    });
    return result;
};
exports.getInitialColumnFilters = getInitialColumnFilters;
var getInitialSortedColumns = function (tableId, columns) {
    if (tableId) {
        var commaSeparatedSortedColumnIds = localStorage.getItem('table-' + tableId + '-sorted-columns');
        if (commaSeparatedSortedColumnIds) {
            return commaSeparatedSortedColumnIds.split(',').map(function (id) { return columns.find(function (column) { return column.id === id; }); }).filter(function (column) { return column; });
        }
    }
    return columns;
};
exports.getInitialSortedColumns = getInitialSortedColumns;
var saveRowsPerPage = function (tableId, rowsPerPage) {
    if (tableId) {
        localStorage.setItem('table-' + tableId + '-rows-per-page', String(rowsPerPage));
    }
};
exports.saveRowsPerPage = saveRowsPerPage;
var saveHiddenColumns = function (tableId, hiddenColumns) {
    if (tableId) {
        localStorage.setItem('table-' + tableId + '-hidden-columns', hiddenColumns.join(','));
    }
};
exports.saveHiddenColumns = saveHiddenColumns;
var saveColumnFilters = function (tableId, columnFilters) {
    if (tableId) {
        localStorage.setItem('table-' + tableId + '-column-filters', JSON.stringify(columnFilters));
    }
};
exports.saveColumnFilters = saveColumnFilters;
var saveSortedColumns = function (tableId, sortedColumns) {
    if (tableId) {
        localStorage.setItem('table-' + tableId + '-sorted-columns', sortedColumns.map(function (c) { return c.id; }).join(','));
    }
};
exports.saveSortedColumns = saveSortedColumns;
